import * as uuid from 'uuid';

export function isUUID(str: string): boolean {
  try {
    return uuid.validate(str);
  } catch {
    return false;
  }
}
